import Image from "next/image"

export default function SiteLogo(props) {

  const logoHeight = parseInt(props.height)
  const logoWidth = parseInt((logoHeight / props.image.height) * props.image.width)

  // return <img src={ props.image.url } alt={props.alt} width={logoWidth + 'px'} height={logoHeight + 'px'} />
  return <Image src={ props.image.url } alt={props.alt} width={logoWidth} height={logoHeight} priority/>


}